'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserIntegrationOAuth } from '../../Entities/User/UserIntegrationOAuth';

export interface UserIntegrationFeatureAvailabilityResponse {
  id: number;
  reference: string;
  name: string;
  account_id?: string;
  external: boolean;
  entityType: string;
  agency_connected_id?: string;
  features: Array<string> | null;
  needs_reconnection: string;
}

export interface UserIntegrationOAuthVoipExtensionsResponse {
  id: number;
  extensionNumber: string;
  extensionId?: string | null;
  extensionName?: string | null;
}

export interface UserIntegrationOAuthVoipPhoneNumbers {
  id: number;
  providerId: string | null;
  appId?: string | null;
  phoneNumber?: string | null;
  phoneNumberName?: string | null;
  phoneNumberId?: string | null;
}

export class UserIntegrationOAuthVoipResourceRepository extends CoreRepository {
  public getUserIntegrationOAuthVoipExtensions(
    userId: number,
    appName: string,
    accountId: number
  ): Promise<Array<UserIntegrationOAuthVoipExtensionsResponse>> {
    return this.webAPI
      .getUserIntegrationOAuthVoipExtensions(userId, appName, accountId)
      .then((response) => {
        return response;
      });
  }

  public getUserIntegrationOAuthVoipPhoneNumbers(
    userId: number,
    appName: string,
    accountId: number
  ): Promise<Array<UserIntegrationOAuthVoipPhoneNumbers>> {
    return this.webAPI
      .getUserIntegrationOAuthVoipPhoneNumbers(userId, appName, accountId)
      .then((response) => {
        return response;
      });
  }

  public getUserIntegrationOAuthVoipPhoneNumbersByExtension(
    userId: number,
    appName: string,
    accountId: number,
    extension: number
  ) {
    return this.webAPI
      .getUserIntegrationOAuthVoipPhoneNumbersByExtension(userId, appName, accountId, extension)
      .then((response) => {
        return response;
      });
  }

  public getUserIntegrationOAuthVoipPhoneNumbersById(
    userId: number,
    appName: string,
    accountId: number,
    phoneId: number
  ) {
    return this.webAPI
      .getUserIntegrationOAuthVoipPhoneNumbersById(userId, appName, accountId, phoneId)
      .then((response) => {
        return response;
      });
  }

  public getUserIntegrationFeatureAvailability(
    userId: number,
    feature: string
  ): Promise<Array<UserIntegrationFeatureAvailabilityResponse>> {
    return this.webAPI.getUserIntegrationFeatureAvailability(userId, feature).then((response) => {
      return response;
    });
  }

  public getUserIntegrationByFeature(userId: number, feature: string) {
    return this.webAPI.getUserIntegrationByFeature(userId, feature).then((response) => {
      return response;
    });
  }

  public placeUserIntegrationOAuthVoipCall(
    userId: number,
    provider: string,
    accountId: number,
    payload: any[]
  ) {
    return this.webAPI
      .placeUserIntegrationOAuthVoipCall(userId, provider, accountId, payload)
      .then((response) => {
        return response;
      });
  }

  public addUserIntegrationOAuthContacts(userId: number, provider: string, payload: any[]) {
    return this.webAPI
      .addUserIntegrationOAuthContacts(userId, provider, payload)
      .then((response) => {
        return response;
      });
  }
}
